import { PrintJobType } from '@/features/print/constants'
import { getPrintersForPrintJobType } from '@/features/print/utils/printerEligibility'
import { RootState } from '@/redux/store'

const sliceSelectors = {
    printers: ({ printers }: RootState) => printers.printers,
}

export const printersSelectors = {
    ...sliceSelectors,
    printerById:
        (id: string) =>
        ({ printers }: RootState) =>
            printers.printers?.find((p) => p.id === id),
    printersByPrintJobType:
        (printJobType: PrintJobType) =>
        ({ printers }: RootState) =>
            getPrintersForPrintJobType(printers.printers ?? [], printJobType),
}
